import { Field } from "../types";
import { Row } from "../components/row/Row";

export const RenderField = (
  field: Field,
  index: number,
  usePadding: boolean,
) => {
  if (field.hidden)
    return (
      <input
        key={index}
        type="hidden"
        name={field.name}
        value={field.value as string}
      />
    );

  return <Row key={index} field={field} usePadding={usePadding} />;
};
